module.exports = __webpack_public_path__ + "media/resume_rev/resume-rev-video-card-images-03-51c84009.jpg";